import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", { class: "q-ma-none" }, "Logg", -1)
const _hoisted_2 = { style: {"white-space":"pre-wrap"} }
const _hoisted_3 = { style: {"white-space":"pre-wrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    "model-value": true,
    onHide: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        square: "",
        style: {"min-width":"900px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pa-none" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_table, {
                flat: "",
                "hide-bottom": "",
                dense: "",
                sort: "",
                "rows-per-page-options": [0],
                rows: _ctx.sortedLog,
                columns: _ctx.columns
              }, {
                "body-cell-was": _withCtx((props) => [
                  _createVNode(_component_q_td, { props: props }, {
                    default: _withCtx(() => [
                      _createElementVNode("pre", _hoisted_2, _toDisplayString(props.value), 1)
                    ]),
                    _: 2
                  }, 1032, ["props"])
                ]),
                "body-cell-change": _withCtx((props) => [
                  _createVNode(_component_q_td, { props: props }, {
                    default: _withCtx(() => [
                      _createElementVNode("pre", _hoisted_3, _toDisplayString(props.value), 1)
                    ]),
                    _: 2
                  }, 1032, ["props"])
                ]),
                _: 1
              }, 8, ["rows", "columns"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_separator),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                label: "Stäng",
                onClick: _ctx.closeModal
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}